import { render, staticRenderFns } from "./inventory-dashboard.vue?vue&type=template&id=1466bc28"
import script from "./inventory-dashboard.vue?vue&type=script&lang=js"
export * from "./inventory-dashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports